import { Box } from '@mui/material';
import styled from 'styled-components';
import { Typography, colors } from '@leapeasy/ui-kit';
import { DetailsCard } from 'elements/DetailsCard';
import { formatOptionalBooleanYesNo } from 'utils/formatBooleanYesNo';
import { formatClaimDetailCurrency } from 'utils/formatClaimDetailCurrency';
import { hasClaimDetailValue } from 'utils/hasClaimDetailValue';

export const RiderDetails = ({ application }) => {
  const tiles = [
    { title: 'ID', value: application.rider_id },
    {
      title: 'Active Lease',
      value: formatOptionalBooleanYesNo(application.rider_active_lease, null),
    },
    { title: 'LDR Coverage', value: formatClaimDetailCurrency(application.rider_ldr_coverage_c) },
    {
      title: 'Coverage requested / mo',
      value: application.rider_coverage_amount_requested_months,
    },
    {
      title: 'Total Coverage Amount',
      value: formatClaimDetailCurrency(application.rider_total_coverage_amount),
    },
    {
      title: 'Gross Annual Rent',
      value: formatClaimDetailCurrency(application.rider_gross_annual_rent),
    },
    {
      title: 'Insurable Value',
      value: formatClaimDetailCurrency(application.rider_insurable_value),
    },
    {
      title: 'Total Number of Residents',
      value: application.rider_total_number_of_tenants,
    },
    { title: 'Total Rent', value: formatClaimDetailCurrency(application.rider_total_rent) },
  ].filter((tile) => hasClaimDetailValue(tile.value));

  if (tiles.length === 0) return null;

  return (
    <Box display="flex" flexDirection="column" gap="10px" padding="24px">
      <Typography variant="h4" style={{ color: colors.purple[900] }}>
        Rider Details
      </Typography>

      <Box display="flex" flexDirection="column" gap="8px">
        <LowContainer>
          {tiles.map((tile) => (
            <DetailsCard key={tile.title} title={tile.title} value={tile.value} />
          ))}
        </LowContainer>
      </Box>
    </Box>
  );
};

const LowContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 8px;
  & > div {
    width: 100%;
  }

  @media screen and (max-width: ${(props) => props.theme.lg}) {
    grid-template-columns: repeat(3, 1fr);
  }
  @media screen and (max-width: ${(props) => props.theme.lg}) {
    grid-template-columns: repeat(2, 1fr);
  }
`;
